const config = {};

config.defaultListSize = 20;

config.listSizeOptions = [
    { key: 5, label: 5 },
    { key: 10, label: 10 },
    { key: 20, label: 20 },
    { key: 50, label: 50 },
];

config.MAX_ALLOWED_SIZE_IN_BYTES = 30000000;

config.CAPTCHA_SITE_KEY = '6LezZDYUAAAAAEKvD3eoTUsZLipBPrmCYc2OEMap';

config.ACCEPTED_FILE_EXTENSIONS = [
    '.bmp',
    '.csv',
    '.doc',
    '.docx',
    '.eml',
    '.gif',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.msg',
    '.pdf',
    '.png',
    '.ppt',
    '.pptx',
    '.rtf',
    '.tiff',
    '.txt',
    '.xls',
    '.xlsx', //,
    // '.odp',
    // '.ods',
    // '.odt'
];

config.ENV_NAME = process.env.REACT_APP_ENV_NAME;

config.GA_TRACKING_ID = 'UA-134947277-1';

config.StatusMessage = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
};

config.currencyPosition = {
    before: 'before',
    after: 'after',
};

config.AUTH_REDIRECT_URI = process.env.REACT_APP_AUTH_REDIRECT_URI;
config.AUTH_TENANT_NAME = process.env.REACT_APP_AUTH_TENANT_NAME;
config.AUTH_TENANT_INSTANCE = process.env.REACT_APP_AUTH_TENANT_INSTANCE;
config.AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
config.AUTH_CLIENT_AUDIENCE_URI =
    process.env.REACT_APP_AUTH_CLIENT_AUDIENCE_URI;

export default config;
